<div id="bulletin" class="mt-4">
  <div class="container">
    <div class="row">
      <div class="col-12 px-lg-0 text-center "><div class="heading"><a href="">Notice Board</a></div></div>
      <div class="col-12 px-lg-0">
        <marquee scrollamount="" behavior="scroll" direction="left" onmouseover="this.stop();" onmouseout="this.start();"><p class="mt-3 pb-4" > 
            <span class="bulletinMarque"></span>
         </p>
        </marquee>
      </div>
    </div>
  </div>
</div>
<!-- Admissions Open (2022-2023) (For complete Admission process, refere to Admission section)  -->